module.exports = __webpack_public_path__ + "img/menu3-1.740de9d9.jpg";